import { render } from "./feature-section.vue?vue&type=template&id=53d912db"
import script from "./feature-section.vue?vue&type=script&lang=js"
export * from "./feature-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__